import React from 'react';

export default function BasicFields({ form, onChange, lockType = false, lockTypeLabel = 'Single occurrence override' }) {
  const durationTotal = Math.max(1, Number(form.durationMinutes) || 60);
  const durationHours = Math.floor(durationTotal / 60);
  const durationRemainingMinutes = durationTotal % 60;

  const handleDurationChange = (part, rawValue) => {
    const numericValue = Math.max(0, Math.floor(Number(rawValue) || 0));
    const nextHours = part === 'hours' ? numericValue : durationHours;
    const nextMinutes = part === 'minutes' ? Math.min(59, numericValue) : durationRemainingMinutes;
    const nextTotal = Math.max(1, (nextHours * 60) + nextMinutes);

    onChange({
      target: {
        name: 'durationMinutes',
        value: String(nextTotal),
        type: 'number'
      }
    });
  };

  return (
    <div className="form-grid">
      <div className="form-field">
        <span className="field-label">Name</span>
        <input id="name" name="name" value={form.name} onChange={onChange} className="input" required />
      </div>

      <div className="form-field">
        <span className="field-label">Type</span>
        {lockType ? (
          <>
            <input className="input" value={lockTypeLabel} readOnly />
            <small className="text-muted">{lockTypeLabel === 'Single occurrence override' ? 'The parent event remains recurring.' : 'The schedule type is locked because tickets have been sold.'}</small>
          </>
        ) : (
          <>
            <select id="type" name="type" value={form.type} onChange={onChange} className="input">
              <option value="oneOff">One-Off</option>
              <option value="recurring">Recurring</option>
            </select>
          </>
        )}
      </div>

      <div className="form-field">
        <span className="field-label">Duration</span>
        <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)', gap: 8 }}>
          <label style={{ display: 'grid', gap: 4 }}>
            <span className="small-muted">Hours</span>
            <input
              id="durationHours"
              name="durationHours"
              type="number"
              min="0"
              step="1"
              value={durationHours}
              onChange={event => handleDurationChange('hours', event.target.value)}
              className="input"
              inputMode="numeric"
            />
          </label>
          <label style={{ display: 'grid', gap: 4 }}>
            <span className="small-muted">Minutes</span>
            <input
              id="durationRemainingMinutes"
              name="durationRemainingMinutes"
              type="number"
              min="0"
              max="59"
              step="1"
              value={durationRemainingMinutes}
              onChange={event => handleDurationChange('minutes', event.target.value)}
              className="input"
              inputMode="numeric"
            />
          </label>
        </div>
      </div>
    </div>
  );
}
